import { render, staticRenderFns } from "./appAuthCode.vue?vue&type=template&id=23505235"
import script from "./appAuthCode.vue?vue&type=script&lang=js"
export * from "./appAuthCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports